module.exports = __webpack_public_path__ + "static/media/date_circle.b33211b8.svg";